// extracted by mini-css-extract-plugin
export default {"SingleAgentBlock":"SingleAgentViewBlock_SingleAgentBlock__M+HcA","ScalingDown":"SingleAgentViewBlock_ScalingDown__xIsm8"};